import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"

import { PageTitle } from "@jewlr/storybook/info"

const InfoLayoutNew = ({
  children,
  heading,
  hidePageTitle,
  isNewDesign,
  layout,
  title,
}) => (
  <>
    <Box contain>
      <Typography
        color="neutral"
        fontSize="14px"
        light
        my={3}
        textAlign={{ _: "center", tablet: "left" }}
      >
        <Link data-lc="info-layout-new" to="/">
          Home
        </Link>{" "}
        /{" "}
        {layout === "press" && (
          <>
            <Link data-lc="info-layout-new" to="/info/press">
              Press
            </Link>{" "}
            /{" "}
          </>
        )}
        {heading || title}
      </Typography>
      {!hidePageTitle && (
        <PageTitle isNewDesign={isNewDesign}>{heading || title}</PageTitle>
      )}
    </Box>
    {children}
  </>
)

InfoLayoutNew.propTypes = {
  children: PropTypes.element.isRequired,
  heading: PropTypes.string,
  hidePageTitle: PropTypes.bool,
  isNewDesign: PropTypes.bool,
  layout: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default InfoLayoutNew
